import React from 'react';
import type { Strategy } from '@cotera/api';
import {
  CUSTOM_CREDENTIAL_STRATEGY_VIEWS,
  UserProvidedStrategyView,
  WorkosPipeStrategyView,
  type CredentialStrategyViewProps,
} from './credential-strategy-views';

export type { CredentialStrategyViewProps } from './credential-strategy-views';
export { UserProvidedStrategyView } from './credential-strategy-views';
export { CUSTOM_CREDENTIAL_STRATEGY_VIEWS } from './credential-strategy-views';

export function resolveCredentialStrategyView(
  strategy: Strategy
): React.FC<CredentialStrategyViewProps> {
  if (strategy.t === 'workos') {
    if (strategy.provider.length > 0) {
      return WorkosPipeStrategyView;
    }
    return UserProvidedStrategyView;
  }

  const customView =
    CUSTOM_CREDENTIAL_STRATEGY_VIEWS[
      strategy.name as keyof typeof CUSTOM_CREDENTIAL_STRATEGY_VIEWS
    ];
  if (customView !== undefined) {
    return customView;
  }

  return UserProvidedStrategyView;
}

/**
 * Renders the credential UI for the selected strategy using
 * {@link resolveCredentialStrategyView} (WorkOS pipe, named custom overrides, or form).
 */
export const CredentialStrategySection: React.FC<
  CredentialStrategyViewProps
> = (props) => {
  const View = resolveCredentialStrategyView(props.strategy.strategy);
  return <View {...props} />;
};
